import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const ssrFailureDisplayEntryPoint = createEntryPoint({
	// eslint-disable-next-line jira/jira-ssr/wrong-entrypoint-usage
	root: JSResourceForUserVisible(() =>
		import(
			/* webpackChunkName: "async-ssr-failure-display" */
			'./ssr-failure-display.tsx'
		).then((module) => module.SSRFailureDisplay),
	),
	getPreloadProps: () => ({}),
});
